// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"9ffc2c7d","409":"db97db90","733":"4ff97864"}[chunkId] + ".chunk.css";
};